import { useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import { toast } from 'react-toastify';
import styled from 'styled-components';

import { utilService } from 'services/util-service';

interface IProps {
  onConfirm: (password: string) => Promise<void>;
}

const ManagerPasswordCheck = ({ onConfirm }: IProps) => {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const { register, handleSubmit, setFocus } = useForm({
    defaultValues: { password: '' },
  });

  const onSubmit = async (data: any) => {
    if (utilService.isEmpty(data.password)) {
      return toast.error('비밀번호를 입력해주세요.');
    }
    setIsSubmitting(true);
    await onConfirm(data.password);
    setIsSubmitting(false);
  };

  useEffect(() => {
    setFocus('password');
  }, [setFocus]);

  return (
    <PasswordCheckWrap>
      <ContentBox>
        <TitleText>비밀번호 재확인</TitleText>
        <SubText>안전한 사용을 위해 비밀번호를 다시 한번 입력해 주세요.</SubText>

        <form onSubmit={handleSubmit(onSubmit)}>
          <HorizontalWrap>
            <ColorWrap />
            <ImageWrap>
              <img src={process.env.PUBLIC_URL + '/images/icon_pw.svg'} alt="pw" />
            </ImageWrap>
            <InputBox
              type="password"
              placeholder="비밀번호"
              {...register('password', { required: true })}
              autoComplete="current-password"
            />
          </HorizontalWrap>

          <SubmitButton type="submit" value={isSubmitting ? '확인 중...' : '확인'} disabled={isSubmitting} />
        </form>
      </ContentBox>
    </PasswordCheckWrap>
  );
};

const PasswordCheckWrap = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  color: white;
  background: #002343;
`;
const ContentBox = styled.div`
  width: 28.1875rem;
  text-align: center;
`;
const TitleText = styled.h2`
  color: #fff;
  font-family: Inter;
  font-size: 1.5rem;
  font-weight: 700;
  margin-bottom: 0.5rem;
`;
const SubText = styled.p`
  font-family: Inter;
  font-size: 0.9rem;
  color: #ccc;
  margin-bottom: 2.5rem;
`;
const HorizontalWrap = styled.div`
  display: flex;
  width: 100%;
  height: 3rem;
  justify-content: center;
  align-items: center;
  margin-bottom: 2rem;
  background: #f5f5f5;
`;
const ColorWrap = styled.div`
  width: 0.375rem;
  height: 3rem;
  background: #e63528;
`;
const ImageWrap = styled.div`
  width: 3rem;
  height: 3rem;
  display: flex;
  justify-content: center;
  align-items: center;
`;
const InputBox = styled.input`
  width: 100%;
  height: 3rem;
  margin-left: 0.81rem;
  padding: 0.8em 0.5em;
  border: none;
  color: #000;
  font-family: Inter;
  font-size: 0.875rem;
  background: #f5f5f5;
  &::placeholder {
    color: #a5a5a5;
  }
  &:focus {
    outline: none;
  }
`;
const SubmitButton = styled.input`
  width: 100%;
  height: 3rem;
  border-radius: 1.47413rem;
  background: #e63528;
  border: 1px solid #e63528;
  cursor: pointer;
  color: #fff;
  text-align: center;
  font-family: Inter;
  font-size: 1rem;
  font-weight: 700;
  transition: opacity 0.2s;
  &:disabled {
    background: #999;
    border-color: #999;
    cursor: not-allowed;
  }
  &:hover {
    opacity: 0.9;
  }
`;

export default ManagerPasswordCheck;
